// https://pixijs.download/v6.1.1/docs/PIXI.Loader.html
// https://ithelp.ithome.com.tw/articles/10205640
export const loader = PIXI.Loader.shared;

// dynamic load "../assets/pixi/" *.js assets
// ref: https://stackoverflow.com/questions/42199872/is-it-possible-to-import-vue-files-in-a-folder
// const files = require.context('../assets/pixi/', false, /\.js$/)
// let assets = {}
// files.keys().forEach((key) => {
//   if (key === './index.js') return
//   const defaultObj = files(key).default
//   assets = {
//     ...assets,
//     ...defaultObj.assets
//   }
// })
// // console.log('modules', assets)
// for (let [key, value] of Object.entries(assets)) {
// loader.add(key, value)
// }

export let sound;
const pathname = location.pathname;
loader.add("music", `${pathname}/resource/music.mp3`);

loader.load((loader, resources) => {
  sound = PIXI.sound.Sound.from(resources["music"].sound);
});

// fixed music broken
// document.addEventListener("visibilitychange", function () {
//   if (document.visibilityState === "visible") {
//     location.reload();
//   }
// });

// //可取得下載進度
// loader.onProgress.add((event) => {
//   console.log("onProgress: ", event);
// });
// //載入檔案錯誤時
// loader.onError.add((target, event, error) => {
//   console.log("onError: ", target, event, error);
// });
// //每個檔案載入時都會呼叫
// loader.onLoad.add((event, target) => {
//   console.log("onLoad: ", event, target);
// });
// //全部下載完成後
// loader.onComplete.add(() => {
//   console.log("onComplete");
// });
